import { Component, ChangeDetectionStrategy } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import type { ActiveList, ListMenuControllerCallbacks } from '@core/prosemirror-legacy';
import { NodeName } from '@core/prosemirror-legacy';
import {
  DropdownComponent,
  DropdownWidth,
  GroupComponent,
  IconButtonComponent,
  RtTooltip,
} from '@core/user-interface-legacy';

@Component({
  selector: 'list-menu',
  imports: [DropdownComponent, GroupComponent, IconButtonComponent, TranslatePipe, RtTooltip],
  templateUrl: './list-menu.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './list-menu.component.less',
})
export class ListMenuComponent {
  public readonly DropdownWidth = DropdownWidth;
  public readonly NodeName = NodeName;

  public close: () => void;
  public unorderedClick: () => void;
  public orderedClick: () => void;
  public getActive: () => ActiveList;

  public setCallbacks(callbacks: ListMenuControllerCallbacks) {
    this.unorderedClick = callbacks.toggleBullets;
    this.orderedClick = callbacks.toggleOrdered;
    this.getActive = callbacks.getActive;
  }
}
